import { ApiService } from './ApiService';

export class NewPasswordService extends ApiService {
    protected basePath = 'setNewPassword';

    public postNewPassword(email: string, reset_token: string, new_password: string): Promise<any> {
        return this.postSubPath(``, { email, reset_token, new_password });
    }
}



// WEBPACK FOOTER //
// ./src/_services/NewPasswordService.ts